import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
import { EditAndDeleteButtons } from "../../../../../../../shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "../../../../../../../shared/data-entries/ManualAutoButton";
import { Probe } from "../../../../models/eaf.models";

type Props = {
  deleteProbe: (probeId: number) => void;
  editProbe: (probeId: number) => void;
};

export const useTableData = ({ deleteProbe, editProbe }: Props) => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Probes",
      children: [
        {
          field: "actions",
          headerName: " ",
          flex: 1,
          cellRenderer: ManualAutoButton,
          cellRendererParams: (params: ICellRendererParams<Probe>) => ({
            isManual: (params.data as Probe).IsProbeManual,
          }),
        },
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Probe>) => {
            if (params?.data?.Timestamp) {
              return dxtToLocalServerTime(params?.data?.Timestamp, "HH:mm");
            }
          },
        },
        {
          field: "Temperature",
          headerName: "Temp",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Temperature?.toFixed(0) || "0",
          flex: 2,
        },
        {
          field: "MWH",
          headerName: "MWH",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.MWH?.toFixed(1) || "0",
          flex: 2,
        },
        {
          field: "Oxygen",
          headerName: "O2",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Oxygen?.toFixed(1) || "0",
          flex: 2,
        },
        {
          field: "Carbon",
          headerName: "Carbon",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Carbon?.toFixed(3) || "0",
          flex: 2,
        },
        {
          field: "actions",
          headerName: " ",
          flex: 2,
          cellRenderer: EditAndDeleteButtons,
          cellRendererParams: (params: ICellRendererParams<Probe>) => ({
            deleteItem: deleteProbe,
            onEdit: editProbe,
            id: (params.data as Probe).ProbeId,
          }),
        },
      ],
    },
  ];

  return { columns };
};
